<template>
  <div class="resolutionLostInfo">
    <TextLink :link-url="lostUserIdUrl" :link-text="lostUserIdText" target-value="_blank" class="lostUserId" />
    <TextLink :link-url="lostPasswordUrl" :link-text="lostPasswordText" target-value="_blank" class="lostPassword" />
  </div>
</template>

<script>
import TextLink from '../../../../common/common/Button/TextLink.vue';

export default {
  name: 'ResolutionLostInfo',
  components: {
    TextLink,
  },
  props: {
    lostUserIdUrl: {
      type: String,
      required: true,
    },
    lostUserIdText: {
      type: String,
      required: true,
    },
    lostPasswordUrl: {
      type: String,
      required: true,
    },
    lostPasswordText: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.resolutionLostInfo {
  display: flex;
  flex-direction: column;
  text-align: right;
  font-size: 14px;
  line-height: 1.5;
}

.lostUserId {
  margin-bottom: 16px;
}
</style>
